import PerformanceChart from '../charts/PerformanceChart/PerformanceChart.jsx'

const Consumption = () => {
  return <PerformanceChart />
}

export default Consumption
